import { render, staticRenderFns } from "./GroupsPage.vue?vue&type=template&id=8eb5828e&"
import script from "./GroupsPage.vue?vue&type=script&lang=js&"
export * from "./GroupsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports